import { DateRange } from '@sympla/sympla-components/Calendar';
import { format } from 'date-fns/format';
import { getDatePeriods } from '@sympla/sympla-components/getDatePeriods.tsx';

const formatDateSearch = (localDate: DateRange | undefined) => {
  if (!localDate?.from) return '';
  return `${format(localDate?.from, 'yyyy-MM-dd')}${
    localDate?.to ? `,${format(localDate.to, 'yyyy-MM-dd')}` : ''
  }`;
};

const datePeriodsList = getDatePeriods();
export const listPredefinedDates = datePeriodsList.map((datePeriod) => ({
  ...datePeriod,
  param: formatDateSearch(datePeriod.period)
}));

// TODO: Modify when 100% in algolia to create a default page, as mapsearch does not have the page next month
export const searchEmptyList = listPredefinedDates.slice(0, -1);
